import { useState } from 'react';
import DrinkMenu from './DrinkMenu';
import AdicionaisMenu from './AdicionaisMenu';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [drinkMenuOpen, setDrinkMenuOpen] = useState(false);
  const [condicoesOpen, setCondicoesOpen] = useState(false);
  const [adicionaisOpen, setAdicionaisOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const openDrinkMenu = () => {
    setDrinkMenuOpen(true);
    setMobileMenuOpen(false);
  };

  const openCondicoes = () => {
    setCondicoesOpen(true);
    setMobileMenuOpen(false);
  };

  const openAdicionais = () => {
    setAdicionaisOpen(true);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center lg:flex-none flex-1 lg:flex-initial justify-center lg:justify-start">
            <img
              src="https://static.readdy.ai/image/7ce29a8f289d24a52677c0daf40c6c66/b23f9805b1736b70d397672c73928a82.png"
              alt="Barem Eventos"
              className="h-16 sm:h-20 w-auto"
            />
          </div>

          {/* Botão Hamburguer */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer z-50"
            aria-label="Menu"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Menu Desktop */}
          <ul className="hidden lg:flex items-center space-x-8 xl:space-x-10">
            <li>
              <button
                onClick={() => scrollToSection('sobre')}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Sobre
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('techbar')}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                TechBar
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('diferenciais')}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Diferenciais
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={() => setDrinkMenuOpen(true)}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Drinks
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('pacotes')}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Experiências
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={openAdicionais}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Adicionais
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <button
                onClick={openCondicoes}
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Condições
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </button>
            </li>
            <li>
              <a
                href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20entrar%20em%20contato%20com%20a%20Barem%20Eventos!"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-white text-xs uppercase tracking-widest font-normal hover:text-[#D4AF37] transition-colors duration-300 relative group cursor-pointer whitespace-nowrap"
              >
                Contato
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] group-hover:w-full transition-all duration-300"></span>
              </a>
            </li>
          </ul>
        </div>

        {/* Menu Mobile */}
        {mobileMenuOpen && (
          <div className="lg:hidden absolute top-20 left-0 right-0 bg-black/95 backdrop-blur-md shadow-2xl border-t border-[#2A2000]">
            <ul className="flex flex-col">
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Sobre
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={() => scrollToSection('techbar')}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  TechBar
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={() => scrollToSection('diferenciais')}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Diferenciais
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={openDrinkMenu}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Drinks
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={() => scrollToSection('pacotes')}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Experiências
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={openAdicionais}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Adicionais
                </button>
              </li>
              <li className="border-b border-[#2A2000]">
                <button
                  onClick={openCondicoes}
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer"
                >
                  Condições
                </button>
              </li>
              <li>
                <a
                  href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20entrar%20em%20contato%20com%20a%20Barem%20Eventos!"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-full text-left px-6 py-5 text-white text-sm uppercase tracking-widest font-light hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all duration-300 cursor-pointer flex items-center gap-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>

      {/* Modal Drinks */}
      {drinkMenuOpen && (
        <div className="fixed inset-0 z-[100] flex flex-col">
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setDrinkMenuOpen(false)}
          />
          <div className="relative z-10 ml-auto w-full max-w-full lg:max-w-5xl h-full bg-[#0D0A06] overflow-y-auto shadow-2xl lg:border-l border-[#2A2000]">
            <button
              onClick={() => setDrinkMenuOpen(false)}
              className="sticky top-0 z-20 w-full flex items-center justify-between px-5 sm:px-10 py-5 bg-[#0D0A06]/95 backdrop-blur-md border-b border-[#2A2000] cursor-pointer group"
            >
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] font-light">
                Drinks
              </span>
              <span className="w-8 h-8 flex items-center justify-center border border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-300">
                <i className="ri-close-line text-white text-lg"></i>
              </span>
            </button>
            <DrinkMenu />
          </div>
        </div>
      )}

      {/* Modal Adicionais */}
      {adicionaisOpen && (
        <div className="fixed inset-0 z-[100] flex">
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setAdicionaisOpen(false)}
          />
          <div className="relative z-10 ml-auto w-full max-w-full lg:max-w-3xl h-full bg-[#0D0A06] overflow-y-auto shadow-2xl lg:border-l border-[#2A2000]">
            <button
              onClick={() => setAdicionaisOpen(false)}
              className="sticky top-0 z-20 w-full flex items-center justify-between px-5 sm:px-10 py-5 bg-[#0D0A06]/95 backdrop-blur-md border-b border-[#2A2000] cursor-pointer group"
            >
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] font-light">
                Adicionais
              </span>
              <span className="w-8 h-8 flex items-center justify-center border border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-300">
                <i className="ri-close-line text-white text-lg"></i>
              </span>
            </button>
            <AdicionaisMenu onClose={() => setAdicionaisOpen(false)} />
          </div>
        </div>
      )}

      {/* Modal Condições */}
      {condicoesOpen && (
        <div className="fixed inset-0 z-[100] flex">
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setCondicoesOpen(false)}
          />
          <div className="relative z-10 ml-auto w-full max-w-full lg:max-w-2xl h-full bg-[#0D0A06] overflow-y-auto shadow-2xl lg:border-l border-[#2A2000]">
            <button
              onClick={() => setCondicoesOpen(false)}
              className="sticky top-0 z-20 w-full flex items-center justify-between px-5 sm:px-10 py-5 bg-[#0D0A06]/95 backdrop-blur-md border-b border-[#2A2000] cursor-pointer group"
            >
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] font-light">
                Condições
              </span>
              <span className="w-8 h-8 flex items-center justify-center border border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-300">
                <i className="ri-close-line text-white text-lg"></i>
              </span>
            </button>

            <div className="px-5 sm:px-10 py-12 space-y-10">
              <div className="text-center">
                <h2 className="text-2xl font-light text-white tracking-widest uppercase mb-3">
                  Condições Comerciais
                </h2>
                <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-4"></div>
                <p className="text-[#A89060] text-sm font-light leading-relaxed">
                  Nossas condições comerciais garantem transparência e segurança em cada etapa do processo.
                </p>
              </div>

              <div className="space-y-6">
                <div className="border border-[#2A2000] p-8 relative">
                  <div className="absolute top-0 left-8 -translate-y-1/2 bg-[#0D0A06] px-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#D4AF37]">
                      <i className="ri-time-line text-base"></i>
                    </div>
                  </div>
                  <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">
                    Duração Padrão
                  </h3>
                  <p className="text-white/80 text-sm font-light leading-relaxed mb-4">
                    Serviço base inclui até <span className="text-[#D4AF37]">5 horas</span> de operação. Horas extras disponíveis sob consulta, conforme necessidade do evento.
                  </p>
                  <div className="space-y-2 border-t border-[#2A2000] pt-4">
                    <div className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-1.5 shrink-0"></span>
                      <p className="text-white/60 text-xs font-light leading-relaxed">
                        Hora extra <span className="text-white/80">antecipada:</span> 20% do valor total do contrato
                      </p>
                    </div>
                    <div className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-1.5 shrink-0"></span>
                      <p className="text-white/60 text-xs font-light leading-relaxed">
                        Hora extra <span className="text-white/80">no dia do evento:</span> 25% do valor total do contrato
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border border-[#2A2000] p-8 relative">
                  <div className="absolute top-0 left-8 -translate-y-1/2 bg-[#0D0A06] px-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#D4AF37]">
                      <i className="ri-bank-line text-base"></i>
                    </div>
                  </div>
                  <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">
                    Forma de Pagamento
                  </h3>
                  <div className="space-y-3">
                    <div className="flex items-center gap-4">
                      <span className="text-3xl font-light text-[#D4AF37]">40%</span>
                      <p className="text-white/70 text-xs font-light leading-relaxed">
                        na assinatura do contrato para reserva da data
                      </p>
                    </div>
                    <div className="w-full h-px bg-[#2A2000]"></div>
                    <div className="flex items-center gap-4">
                      <span className="text-3xl font-light text-[#D4AF37]">60%</span>
                      <p className="text-white/70 text-xs font-light leading-relaxed">
                        restantes até <span className="text-white/90">10 dias antes</span> do evento
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border border-[#2A2000] p-8 relative">
                  <div className="absolute top-0 left-8 -translate-y-1/2 bg-[#0D0A06] px-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#D4AF37]">
                      <i className="ri-bank-card-line text-base"></i>
                    </div>
                  </div>
                  <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">
                    Pagamento em Cartão
                  </h3>
                  <p className="text-white/70 text-sm font-light leading-relaxed">
                    Pagamento via cartão de crédito ou débito disponível <span className="text-white/90">sob consulta</span>, conforme modalidade e valor contratado.
                  </p>
                </div>

                <div className="border border-[#D4AF37]/30 p-8 relative bg-[#D4AF37]/5">
                  <div className="absolute top-0 left-8 -translate-y-1/2 bg-[#0D0A06] px-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#D4AF37]">
                      <i className="ri-calendar-check-line text-base"></i>
                    </div>
                  </div>
                  <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">
                    Validade da Proposta
                  </h3>
                  <p className="text-white/70 text-sm font-light leading-relaxed">
                    Esta proposta é válida por prazo determinado. Entre em contato para confirmar disponibilidade e garantir sua data.
                  </p>
                </div>

                <div className="border border-[#2A2000] p-8 relative">
                  <div className="absolute top-0 left-8 -translate-y-1/2 bg-[#0D0A06] px-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#D4AF37]">
                      <i className="ri-layout-line text-base"></i>
                    </div>
                  </div>
                  <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light mb-4">
                    Estruturas
                  </h3>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-1.5 shrink-0"></span>
                      <p className="text-white/70 text-sm font-light leading-relaxed">
                        Em pacotes, somente são inclusas estruturas <span className="text-white font-normal">lineares</span>.
                      </p>
                    </div>
                    <div className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-1.5 shrink-0"></span>
                      <p className="text-white/70 text-sm font-light leading-relaxed">
                        Estruturas <span className="text-white font-normal">360</span> e <span className="text-white font-normal">bar ilha</span> ficam por conta da decoração do evento.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center pt-4">
                <a
                  href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20entrar%20em%20contato%20com%20a%20Barem%20Eventos!"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light px-10 py-4 hover:bg-[#D4AF37] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-sm"></i>
                  Entrar em Contato
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
